import React from 'react';
import { Form } from 'react-bootstrap';

const formatNumber = (value) => {
    if (!value && value !== 0) return '';
    // Parse as number first to handle decimals correctly
    const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d.-]/g, '')) : parseFloat(value);
    if (isNaN(numericValue)) return '';
    // Round to remove decimals and format with thousand separators
    return Math.round(numericValue).toLocaleString('es-CO');
};

const parseNumber = (formattedValue) => {
    if (!formattedValue) return '';
    // Remove all non-digits
    return formattedValue.replace(/\D/g, '');
};

const NumberInput = ({
    value,
    onChange,
    placeholder = '0',
    disabled = false,
    name,
    ...rest
}) => {
    const [displayValue, setDisplayValue] = React.useState('');

    React.useEffect(() => {
        setDisplayValue(formatNumber(value));
    }, [value]);

    const handleChange = (e) => {
        const input = e.target.value;
        const numericValue = parseNumber(input);

        // Update display with formatted value
        setDisplayValue(formatNumber(numericValue));

        // Call parent onChange with raw numeric value
        if (onChange) {
            onChange(numericValue);
        }
    };

    return (
        <Form.Control
            type="text"
            value={displayValue}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            name={name}
            {...rest}
        />
    );
};

export default NumberInput;
